module.exports = __webpack_public_path__ + "static/media/a37b2857-17b2-4873-b57c-ef355809a6bb_1.11e0e7b4b90e5abf3c510c94eef4a6cb.27f6bf01.png";